export const capitalizeText = (text: string): string =>
  text.toLowerCase().replace(/(?:^|\s)\S/g, match => match.toUpperCase())

export const capitalizeFirstLetter = (str: string): string =>
  `${str.charAt(0).toUpperCase()}${str.slice(1).trim()}`
